import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=4c1a0124&scoped=true"
import script from "./NavComponent.vue?vue&type=script&lang=js"
export * from "./NavComponent.vue?vue&type=script&lang=js"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=4c1a0124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a0124",
  null
  
)

export default component.exports